import {
    getMedicalRecordEndpoint,
    getMedicalRecordPdfUrlEndpoint,
    getMedicalRecordsListEndpoint
} from "./medicalRecordsEndpoints";
import {MedicalRecordDto} from "../../types/medicalRecord";
import {http, rawHttp} from "../../services/http";

class MedicalRecordsApi {
    getMedicalRecordsList(appointmentId: number) {
        return http.get<MedicalRecordDto[]>(getMedicalRecordsListEndpoint(appointmentId));
    }

    getMedicalRecord(appointmentId: number)
    {
        return rawHttp.get<MedicalRecordDto>(getMedicalRecordEndpoint(appointmentId));
    }

    getMedicalRecordPdfUrl(medicalRecordId: string) {
        return http.get<string>(getMedicalRecordPdfUrlEndpoint(medicalRecordId));
    }
}

export const medicalRecordsApi = new MedicalRecordsApi();
